import { Box, styled, Typography } from '@mui/material';

export const Container = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '0 40px 64px 40px',
}));

export const ContainerInfo = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: 6,
}));

export const TopContainer = styled('div')(() => ({
  margin: '45px 0',
  width: '100%',
  display: 'flex',
  justifyContent: 'end',
}));

export const Span = styled('span')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  fontWeight: 400,
  '& .arrow-forward': {
    fontSize: '16px',
  },
}));

export const Label = styled('label')(() => ({
  fontWeight: 500,
  marginRight: '4px',
}));

export const StatusBadge = styled('div')(({ theme }) => ({
  width: 6,
  height: 6,
  borderRadius: 6,
  backgroundColor: theme.palette.secondary.main,
}));

export const ErrorBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '28px',
  padding: '0 8px',
  marginLeft: '8px',

  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  gap: '4px',

  border: '1px solid #DADADA',
  borderRadius: '8px',

  svg: {
    color: '#FFD113',
    fontSize: '16px',
  },
}));

export const DateTypography = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 16,
  lineHeight: '28px',
}));

export const DurationTypography = styled(Typography)(() => ({
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '28px',
  marginTop: -8,
}));
